/* Global Styles */
.text-field :global {
    margin: var(--spacing-10) 0;
}

/* Global Input Styles */
.text-field :global .MuiTextField-root .MuiOutlinedInput-root {
    background: var(--color-white);
    transition: 100ms linear;
}

.text-field :global .MuiTextField-root .MuiOutlinedInput-root:hover {
    background-color: var(--color-off-white);
}

/* Useful when rendering a text field on an off-white background */
.text-field.hover-white :global .MuiTextField-root .MuiOutlinedInput-root:hover {
    background-color: var(--color-white);
}

.text-field :global .MuiTextField-root input {
    border-radius: 5px;
    padding: 16.5px var(--spacing-20);
}

.text-field :global .MuiTextField-root .MuiOutlinedInput-root {
    background-color: var(--color-white);
    transition: 100ms linear;
}

.text-field :global .MuiTextField-root .MuiOutlinedInput-notchedOutline {
    border-color: var(--color-black);
}

/* Global Label Styles */
.text-field :global .MuiTextField-root .MuiFormLabel-root {
    color: var(--color-grey);
    font-family: 'Grotesk Regular', sans-serif;
}

.text-field :global .MuiTextField-root .MuiInputLabel-shrink {
    color: var(--color-black);
    background-color: var(--color-white);
    border-radius: 6px;
    padding: 2px 8px;
    font-family: 'Grotesk Bold', sans-serif;
    font-weight: 800;
    left: -6px;
}

.text-field :global .MuiTextField-root .MuiFormLabel-asterisk {
    color: var(--color-black);
}

/* Focused Input */
.text-field :global .MuiTextField-root .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--color-black);
    border-width: 1px;
    outline: 0;
}

/* Error Input */
.text-field :global .MuiTextField-root .Mui-error {
    color: var(--color-black);
}

.text-field :global .MuiTextField-root .Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: var(--color-error);
}

.text-field :global .MuiTextField-root .Mui-error .MuiFormLabel-asterisk {
    color: var(--color-error);
}

/* Disabled Input */
.text-field :global .MuiTextField-root .Mui-disabled,
.text-field :global .MuiTextField-root .Mui-disabled .MuiFormLabel-asterisk {
    color: var(--color-black);
}

.text-field :global .MuiTextField-root .Mui-disabled input,
.text-field :global .MuiTextField-root .Mui-disabled.MuiInputBase-multiline {
    background: var(--color-grey-light);
    cursor: not-allowed;
}

.text-field :global .MuiTextField-root .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border: none;
}

.text-field :global .MuiTextField-root .Mui-disabled.MuiInputLabel-shrink .MuiFormLabel-asterisk {
    color: var(--color-error);
}

/* Conditional Styles */
.text-field :global .MuiTextField-root .with-apply-btn {
    padding-right: 90px;
}

.text-field :global .MuiInputAdornment-root.dollar-sign {
    margin-right: -15px;
}

.text-field :global .MuiInputAdornment-root.dollar-sign .MuiTypography-root {
    color: var(--color-black);
}
